/* External */
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export default function useLiveContentTexts() {
  const { formatMessage } = useIntl();
  return useMemo(() => (
    {
      texts: {
        startsAt: formatMessage({ id: 'live.startAtTimeLeft' }),
        endsIn: formatMessage({ id: 'live.endTimeLeft' }),
      },
      time: {
        day: {
          today: formatMessage({ id: 'common.today' }),
          tomorrow: formatMessage({ id: 'common.tomorrow' }),
          monday: formatMessage({ id: 'common.monday' }),
          tuesday: formatMessage({ id: 'common.tuesday' }),
          wednesday: formatMessage({ id: 'common.wednesday' }),
          thursday: formatMessage({ id: 'common.thursday' }),
          friday: formatMessage({ id: 'common.friday' }),
          saturday: formatMessage({ id: 'common.saturday' }),
          sunday: formatMessage({ id: 'common.sunday' }),
        },
        hours: {
          singular: formatMessage({ id: 'common.hourSingularLeft' }),
          plural: formatMessage({ id: 'common.hoursPluralLeft' }),
        },
        minutes: formatMessage({ id: 'common.minutesSingularShortLeft' }),
      },
    }
  ), [formatMessage]);
}
